var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRipio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 958 546",
    viewBox: "0 0 958 546",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7908ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.4 231.6h.5c8.6-15.6 23.5-22.6 41.1-22.6h8.7v43.4c-6.2-3.5-12.2-4.2-19.1-4.2-25.1 0-31.3 16.6-31.3 38.5v51.3h-45.1v-127.2h45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.1 210.8h45.1v127.3h-45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.4 225.2h.5c8.2-12.6 23.6-18.6 38.5-18.6 38 0 64.2 31.8 64.2 68.2 0 36.7-26 67.5-63.8 67.5-14.6 0-29.8-5.2-39.4-16.4v69.7l-45.2 19.1v-203.9h45.2zm-1.5 49.3c0 16.1 10.7 28.5 29 28.5s29-12.4 29-28.5c0-15.6-10.7-28.8-29-28.8s-29 13.2-29 28.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.6 210.8h45.2v127.3h-45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m776.8 274.5c0 43.2-35.7 67.7-76.7 67.7-40.7 0-76.7-24.3-76.7-67.7s35.7-68 76.7-68 76.7 24.6 76.7 68m-105.7 0c0 16.1 10.7 28.5 29 28.5s29-12.4 29-28.5c0-15.6-10.7-28.8-29-28.8s-29 13.2-29 28.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.2 175.4-44.1 17.8v-42.1l44.2-17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.2 175.4-44.1 17.8v-42.1l44.2-17.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipio);
export default __webpack_public_path__ + "static/media/ripio.c3fae0ad773c757c2bd6f1f39bcc473a.svg";
export { ForwardRef as ReactComponent };